import { z } from "zod";

export const LinkType = z.enum(["meeting", "personal", "oneTime", "chat", "screen", "roamUProf"]);
export type LinkType = z.infer<typeof LinkType>;
